import { Fragment, useContext, useEffect } from "react";
import { NewCardPayment } from "../../CheckOutNew/Payment/paymentMethod/newcardPayment";
import { GlobalContext } from "../../../Context/GlobalContext";
import { PayaccountMyWalletPayment } from "./myWalletPayment";
import { GuestDetailsForm } from "./guestDetailsForm";
import { TillGooglePayOption } from "../../PayOnline/tillGooglePayOption";
import { useAuth } from "../../../Context/AuthContext";
import { TILL_GPAY_PAYACCOUNT_ENABLED } from "../../../constants";
import $ from "jquery";

export const PaymentSelection = ({ googlePayAmount, onGooglePayBeforePay, onGooglePayToken } = {}) => {
  const { selectedPaymentType, setSelectedPaymentType } = useContext(GlobalContext);
  const { isAuthenticated } = useAuth();
  useEffect(() => {
    handlePaymentSelection("NEWCARD");
  }, [isAuthenticated]);
  const handlePaymentSelection = (e) => {
    if (e == "NEWCARD") {
      $(".card-details-list1").show("slow");
      $(".tillgpay-details-list").hide("slow");
      $(".acc-details-list1").hide("slow");
      $(".banktransfer").hide("slow");
    } else if (e == "TILLGOOGLEPAY") {
      $(".card-details-list1").hide("slow");
      $(".tillgpay-details-list").show("slow");
      $(".acc-details-list1").hide("slow");
      $(".banktransfer").hide("slow");
    } else {
      $(".card-details-list1").hide("slow");
      $(".tillgpay-details-list").hide("slow");
      $(".acc-details-list1").hide("slow");
      $(".banktransfer").hide("slow");
    }
    setSelectedPaymentType(e);
  };
  return (
    <Fragment>
      <div className="selected-shipping-method  col-lg-10">
        <div className="myAcc-list">
          <h2>Payment</h2>
        </div>
        <div className="shipping-method-list">
          <div className="shipPayment-listing shipPayment-fix" id="accordionExample">
            <NewCardPayment handleOnCheck={handlePaymentSelection} defaultCheck={selectedPaymentType == "NEWCARD"} />

            {TILL_GPAY_PAYACCOUNT_ENABLED && (
              <TillGooglePayOption
                handleOnCheck={handlePaymentSelection}
                defaultCheck={selectedPaymentType == "TILLGOOGLEPAY"}
                TotalAmount={googlePayAmount}
                onBeforePay={onGooglePayBeforePay}
                onToken={onGooglePayToken}
                enabled={TILL_GPAY_PAYACCOUNT_ENABLED}
              />
            )}

            {isAuthenticated && <PayaccountMyWalletPayment handleOnCheck={handlePaymentSelection} />}
          </div>
        </div>
      </div>
    </Fragment>
  );
};
